//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'anchor',
  props: {
    selected: String,
    anchors: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    scrollToView: function scrollToView(event) {
      var target = event.target || event.currentTarget;
      var _ref = target.dataset || {},
        id = _ref.id;
      this.$emit('scrollToViewFn', id);
    }
  }
};